import { BiCreditCard } from "react-icons/bi";
import { FaFaceSmile } from "react-icons/fa6";
import { FiCheckCircle } from "react-icons/fi";
import { HiDocumentMagnifyingGlass } from "react-icons/hi2";
import { PiUserCircleGearDuotone } from "react-icons/pi";

const stepRegister = [
  {
    title: "Account Creation",
    description: "Create your account",
    icon: <PiUserCircleGearDuotone className="h-5 w-5" />,
  },
  {
    title: "Select Plan",
    description: "Choose your package",
    icon: <HiDocumentMagnifyingGlass className="h-5 w-5" />,
  },
  {
    title: "Payment",
    description: "Complete payment",
    icon: <BiCreditCard className="h-5 w-5" />,
  },
  {
    title: "Verification",
    description: "Verify payment",
    icon: <FiCheckCircle className="h-5 w-5" />,
  },
  {
    title: "Done",
    description: "",
    icon: <FaFaceSmile className="h-5 w-5" />,
  },
];

const stepAdCredit = [
  {
    title: "Payment",
    description: "Complete payment",
    icon: <BiCreditCard className="h-5 w-5" />,
  },
  {
    title: "Verification",
    description: "Verify payment",
    icon: <FiCheckCircle className="h-5 w-5" />,
  },
  {
    title: "Done",
    description: "",
    icon: <FaFaceSmile className="h-5 w-5" />,
  },
];

const step = {
  stepRegister,
  stepAdCredit,
};

export default step;
